import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const SHEET_URL = "https://docs.google.com/spreadsheets/d/12m-FcG8WXgEm77jaHIhg0_Yw-j_U89M4ZjCuagetsc8/edit?usp=sharing";

export default function ControlSheet() {
  return (
    <div className="h-[calc(100vh-80px)] flex flex-col" data-testid="control-sheet-page">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-2xl font-bold">Hoja de Control</h2>
      </div>
      <Card className="flex-1 overflow-hidden">
        <CardContent className="p-0 h-full">
          <iframe
            src={SHEET_URL}
            className="w-full h-full border-0 rounded-lg"
            title="Hoja de Control"
            allow="clipboard-read; clipboard-write"
          />
        </CardContent>
      </Card>
    </div>
  );
}
